import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DialPlanGroupInventoryEntry, JobStatus } from '../../../shared/models/generated/ziroModels';
import { FileDownloadService } from '../../../shared/services/file-download.service';

@Injectable()
export class MicrosoftDialPlanInventoryReportResource {
  private $http = inject(HttpClient);
  private fileDownloadService = inject(FileDownloadService);

  get(tenantId: string): Observable<DialPlanGroupInventoryEntry[]> {
    return this.$http.get<DialPlanGroupInventoryEntry[]>(
      `/services/microsoft/reporting/tenants/${tenantId}/dial-plan-inventory`,
    );
  }

  refresh(tenantId: string): Observable<void> {
    return this.$http.post<void>(`/services/microsoft/reporting/tenants/${tenantId}/dial-plan-inventory/refresh`, null);
  }

  status(tenantId: string): Observable<JobStatus> {
    return this.$http.get<JobStatus>(`/services/microsoft/reporting/tenants/${tenantId}/dial-plan-inventory/status`);
  }

  export(tenantId: string): Observable<void> {
    return this.fileDownloadService.downloadFile(
      `/services/microsoft/reporting/tenants/${tenantId}/dial-plan-inventory/export`,
    );
  }
}
